import { render, staticRenderFns } from "./gasstation.vue?vue&type=template&id=5060a824&scoped=true"
import script from "./gasstation.vue?vue&type=script&lang=js"
export * from "./gasstation.vue?vue&type=script&lang=js"
import style0 from "./gasstation.vue?vue&type=style&index=0&id=5060a824&prod&lang=css"
import style1 from "./gasstation.vue?vue&type=style&index=1&id=5060a824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5060a824",
  null
  
)

export default component.exports